export enum HighlightItemTextAlign {
  Center = "center",
  Left = "left",
}
